<!--
 * @Descripttion: 发起申请弹窗
 * @Author: liaoyijun
 * @Date: 2021-08-17 10:07:39
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-09-22 13:50:43
-->

<template>
    <el-dialog
        title="发起申请"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :visible.sync="visible"
        width="1000px"
        @close="closeDialog"
    >
        <div class="apply-dialog-container">
            <div :class="['row-container', { center: dataList.length === 0 }]">
                <div v-if="dataList.length === 0" class="noData">
                    <no-empty>暂无数据</no-empty>
                </div>
                <div v-for="item in dataList" v-else :key="item.id" class="col-container">
                    <div class="title-box">
                        {{ item.processCategoryName }}
                    </div>
                    <div class="group-container">
                        <div v-for="group in item.processGroups" :key="group.id" class="apply-content-box">
                            <div class="group-title">
                                <span>
                                    {{ group.processGroupName }}
                                </span>
                            </div>
                            <div class="group-content">
                                <div
                                    v-for="process in group.processList"
                                    :key="process.id"
                                    class="apply-item"
                                    @click="openWin(process.ssoUrl)"
                                >
                                    <i :class="['iconnewhope', process.icon]" :style="{ color: process.color }"></i>
                                    <span>{{ process.processName }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="more" @click="viewMore(item)">
                        查看更多
                    </div>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import { getProcessList } from "@/api";
import { getLocalStorage } from "@/libs/mUtils";
import NoEmpty from "@/components/no-empty";
export default {
    components: {
        NoEmpty,
    },
    data() {
        return {
            dataList: [],
            visible: false,
        };
    },
    mounted() {
        this.getProcessList();
    },
    methods: {
        async getProcessList() {
            try {
                const { body, code, message } = await getProcessList();
                if (code === "0000") {
                    this.dataList = body;
                } else {
                    this.$message.error(message);
                }
            } catch (err) {
                console.error(err);
            }
        },
        openWin(url) {
            window.open(url);
        },
        show() {
            this.visible = true;
            this.getProcessList();
        },
        closeDialog() {
            this.visible = false;
        },
        viewMore(item) {
            const name = item.processCategoryName;
            let url = "";
            if (name === "OA流程") {
                url = this.$config.applyOaUrl;
            } else if (name === "人力资源") {
                url = this.$config.applyHrUrl;
            } else if (name === "费用报销") {
                url = this.formatReim();
            } else {
                this.$message.error("请重新选择正确的申请栏目！");
                return;
            }
            window.open(url);
        },
        // 解析费用报销地址
        formatReim() {
            // 1263443263498809345 地产总部
            // 1263444169219690497 城市公司
            // 1131968416541462533 四川总部
            // 1263443593787666433 新希望服务
            const reim_white_list = [
                "1263443263498809345",
                "1263444169219690497",
                "1131968416541462533",
                "1263443593787666433",
            ];
            let orgId = "";
            const auth_user = getLocalStorage("user");
            const orgList = auth_user.userData.departmentPath.split(",");
            for (let i = 0; i < reim_white_list.length; i++) {
                const pId = reim_white_list[i];
                if (orgList.includes(pId)) {
                    orgId = pId;
                    break;
                }
            }
            if (!orgId) {
                orgId = reim_white_list[0];
            }
            return this.$config.applyReimUrl.get(orgId);
        },
    },
};
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__header {
    text-align: center;
    border-radius: 8px 8px 0 0;
    .el-dialog__title {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
    }
}
/deep/ .el-dialog {
    border-radius: 8px;
}
/deep/ .el-dialog__body {
    display: flex;
    justify-content: center;
    padding-left: 0;
    padding-right: 0;
}
.apply-dialog-container {
    width: 960px;
    // height: 668px;
    .row-container {
        display: flex;
        position: relative;
        width: 100%;
        height: 578px;
        clear: both;
        white-space: nowrap !important;
        overflow-x: auto;
        overflow-y: hidden;
        background: #fff;
        &.center {
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .col-container {
            position: relative;
            display: inline-block;
            width: 306px;
            // width: 225px;
            height: 578px;
            background: #ffffff;
            border-radius: 8px;
            border: 1px solid #e8eaec;
            &:not(:last-child) {
                margin-right: 20px;
            }
            .title-box {
                width: 100%;
                height: 40px;
                background: #eef7f7;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #68b59f;
                border-radius: 8px 8px 0 0;
            }

            .group-container {
                width: 100%;
                height: calc(100% - 80px);
                overflow-y: auto;
                .group-title {
                    margin-left: 10px;
                    margin-right: 10px;
                    border-bottom: 1px dashed #dadcdf;
                    padding-top: 30px;
                    padding-bottom: 10px;
                    margin-bottom: 15px;
                }
                .group-content {
                    .apply-item {
                        padding: 5px;
                        display: flex;
                        align-items: center;
                        margin-left: 5px;
                        margin-bottom: 5px;
                        cursor: pointer;
                        span {
                            margin-left: 8px;
                        }
                    }
                }
            }

            .more {
                display: flex;
                align-items: center;
                justify-content: center;
                color: #68b59f;
                height: 40px;
                margin: 0 20px;
                position: absolute;
                left: 0;
                right: 0;
                bottom: 0;
                border-top: 1px solid #eff1f3;
                background: #ffffff;
                cursor: pointer;
            }
        }
    }
}
</style>
